/**
 * ============================================================================
 * RK PRODUCT HERO JAVASCRIPT
 * Product Detail Page Interactions
 * ============================================================================
 *
 * Powered by René Kress - Crovio
 * www.crovio.de
 *
 * © 2025 All Rights Reserved
 * ============================================================================
 */

(function() {
  'use strict';
  
  const productSection = document.querySelector('.rk-product-hero');
  if (!productSection) return;
  
  // Get Product JSON
  let product = null;
  try {
    const productJson = document.getElementById('rk-product-json');
    if (productJson && productJson.textContent) {
      product = JSON.parse(productJson.textContent);
      console.log('RK Product Hero - Product loaded:', product?.title);
    }
  } catch (error) {
    console.error('RK Product Hero - Error parsing product JSON:', error);
  }
  
  // Get Delivery Settings
  let deliverySettings = null;
  try {
    const deliverySettingsEl = document.getElementById('rk-delivery-settings');
    if (deliverySettingsEl && deliverySettingsEl.textContent) {
      deliverySettings = JSON.parse(deliverySettingsEl.textContent);
      console.log('RK Product Hero - Delivery settings loaded:', deliverySettings);
    }
  } catch (error) {
    console.error('RK Product Hero - Error parsing delivery settings:', error);
  }
  
  // Elements
  const mainImg = document.getElementById('rk-main-img');
  const thumbnails = document.querySelectorAll('.rk-product-hero__thumb');
  const variantIdInput = document.getElementById('rk-variant-id');
  const priceEl = document.getElementById('rk-price');
  const skuEl = document.getElementById('rk-sku');
  const stockEl = document.getElementById('rk-stock');
  const addToCartBtn = document.getElementById('rk-add-to-cart');
  const qtyInput = document.getElementById('rk-qty-input');
  const qtyMinus = document.getElementById('rk-qty-minus');
  const qtyPlus = document.getElementById('rk-qty-plus');
  const productForm = document.getElementById('rk-product-form');
  const wishlistBtn = productSection.querySelector('.rk-product-hero__wishlist');
  const shareBtn = document.getElementById('rk-share-btn');
  const zoomBtn = document.getElementById('rk-zoom-btn');
  const lightbox = document.getElementById('rk-lightbox');
  const deliveryDateEl = document.getElementById('rk-delivery-date');
  
  // Current selections
  let currentOptions = {};

  // ==========================================
  // HELPER: Hauptbild setzen
  // srcset muss geleert werden, da Browser es über src priorisieren
  // ==========================================

  function setMainImage(imageUrl, zoomUrl) {
    if (!mainImg) return;
    mainImg.srcset = '';
    mainImg.src = imageUrl;
    if (zoomUrl) {
      mainImg.dataset.zoom = zoomUrl;
    }
  }
  
  // ==========================================
  // PRELOAD THUMBNAIL IMAGES
  // ==========================================

  function preloadThumbnailImages() {
    thumbnails.forEach(thumb => {
      const img = new Image();
      img.src = thumb.dataset.image;
    });
  }

  preloadThumbnailImages();

  // ==========================================
  // THUMBNAIL NAVIGATION
  // ==========================================
  
  thumbnails.forEach(thumb => {
    thumb.addEventListener('click', function() {
      const imageUrl = this.dataset.image;
      const zoomUrl = this.dataset.zoom;
      
      // Hauptbild updaten (srcset leeren, damit src greift)
      setMainImage(imageUrl, zoomUrl);
      
      // Active-State updaten
      thumbnails.forEach(t => t.classList.remove('rk-product-hero__thumb--active'));
      this.classList.add('rk-product-hero__thumb--active');
    });
  });
  
  // ==========================================
  // VARIANT SELECTION
  // ==========================================
  
  // Initialize current options
  if (product && product.options) {
    product.options.forEach((option, index) => {
      if (option.values && option.values.length > 0) {
        currentOptions['option' + (index + 1)] = option.values[0];
      }
    });
    console.log('RK Product Hero - Current options initialized:', currentOptions);
  }
  
  // Variant Buttons
  const variantButtons = productSection.querySelectorAll('.rk-product-hero__option-btn');
  variantButtons.forEach(btn => {
    btn.addEventListener('click', function() {
      const optionPosition = this.dataset.option;
      const optionValue = this.dataset.value;
      
      // Update UI - Remove active from all buttons in this option group
      const optionGroup = this.closest('.rk-product-hero__option');
      optionGroup.querySelectorAll('.rk-product-hero__option-btn').forEach(b => {
        b.classList.remove('rk-product-hero__option-btn--active');
        b.setAttribute('aria-pressed', 'false');
      });
      
      // Add active to clicked button
      this.classList.add('rk-product-hero__option-btn--active');
      this.setAttribute('aria-pressed', 'true');
      
      // Update selected text
      const selectedText = optionGroup.querySelector('[id^="rk-selected-"]');
      if (selectedText) {
        selectedText.textContent = optionValue;
      }
      
      // Update current options
      currentOptions['option' + optionPosition] = optionValue;
      
      // Find matching variant
      updateVariant();
    });
  });
  
  // Variant Dropdowns
  const variantSelects = productSection.querySelectorAll('.rk-product-hero__option-select');
  variantSelects.forEach(select => {
    select.addEventListener('change', function() {
      const optionPosition = this.dataset.option;
      const optionValue = this.value;
      
      // Update current options
      currentOptions['option' + optionPosition] = optionValue;
      
      // Find matching variant
      updateVariant();
    });
  });
  
  function updateVariant() {
    if (!product || !product.variants) return;
    
    // Find matching variant
    const variant = product.variants.find(v => {
      return v.option1 === currentOptions.option1 &&
             (v.option2 === currentOptions.option2 || !currentOptions.option2) &&
             (v.option3 === currentOptions.option3 || !currentOptions.option3);
    });
    
    if (variant) {
      // Update variant ID
      if (variantIdInput) {
        variantIdInput.value = variant.id;
      }
      
      // Update price
      if (priceEl) {
        let priceHTML = '';
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceHTML = '<span class="rk-product-hero__price--sale">' + formatMoney(variant.price) + '</span>' +
                      '<span class="rk-product-hero__price--compare">' + formatMoney(variant.compare_at_price) + '</span>' +
                      '<span class="rk-kb__spar">−' + Math.floor((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) + ' %</span>';
        } else {
          priceHTML = '<span class="rk-product-hero__price--regular">' + formatMoney(variant.price) + '</span>';
        }
        priceEl.innerHTML = priceHTML;
      }

      // Grundpreis je Meter (Paragraf 4 PAngV) mitziehen - aus Shopify, wenn
      // gepflegt, sonst aus der Laenge, die das Snippet im Titel erkannt hat.
      var gp = productSection.querySelector('[data-rk-grundpreis]');
      if (gp) {
        var wert = gp.querySelector('[data-rk-grundpreis-wert]');
        var meter = parseFloat(gp.getAttribute('data-rk-meter') || '0');
        if (variant.unit_price && variant.unit_price_measurement) {
          var m = variant.unit_price_measurement;
          wert.textContent = formatMoney(variant.unit_price) + ' / ' + m.reference_value + ' ' + m.reference_unit;
        } else if (meter > 0) {
          wert.textContent = formatMoney(Math.round(variant.price / meter)) + ' / 1 m';
        }
      }

      // Artikelnummer: nur zeigen, wenn die Variante eine hat
      if (skuEl) {
        skuEl.textContent = variant.sku || '';
        var skuZeile = skuEl.closest('.rk-product-hero__sku');
        if (skuZeile) skuZeile.hidden = !variant.sku;
      }
      
      // Update stock
      if (stockEl) {
        updateStock(variant);
      }
      
      // Update add to cart button
      if (addToCartBtn) {
        if (variant.available) {
          addToCartBtn.disabled = false;
          addToCartBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>In den Warenkorb';
        } else {
          addToCartBtn.disabled = true;
          addToCartBtn.textContent = 'Ausverkauft';
        }
      }
      
      // Update image if variant has image
      if (variant.featured_image && mainImg) {
        const newImageUrl = variant.featured_image.src;
        const zoomUrl = newImageUrl.replace(/(\.[^.]+)$/, '_2400x$1');

        // srcset leeren, damit src-Zuweisung greift
        setMainImage(newImageUrl, zoomUrl);
        
        // Update thumbnails - mark the matching one as active
        thumbnails.forEach(thumb => {
          const thumbMediaId = thumb.dataset.mediaId;
          if (variant.featured_image && thumbMediaId == variant.featured_image.id) {
            thumb.classList.add('rk-product-hero__thumb--active');
          } else {
            thumb.classList.remove('rk-product-hero__thumb--active');
          }
        });
      }
    }
  }
  
  /* Bestand je Variante kommt aus #rk-bestand (Liquid). Die Produkt-JSON im
     Shop enthält keinen Bestand – vorher stand nach jedem Variantenwechsel
     gar nichts mehr da. „Nur noch X“ nur, wenn Shopify den Bestand zählt. */
  let bestand = {};
  try {
    const bestandEl = document.getElementById('rk-bestand');
    if (bestandEl) bestand = JSON.parse(bestandEl.textContent);
  } catch (e) { bestand = {}; }

  function updateStock(variant) {
    const b = bestand[variant.id] || { da: variant.available, menge: 0, gezaehlt: false, schwelle: 10 };
    let text = '';
    let knapp = false;
    if (!b.da) {
      text = 'Gerade ausverkauft';
    } else if (b.gezaehlt && b.menge > 0 && b.menge <= b.schwelle) {
      text = 'Nur noch <strong>' + b.menge + '</strong> auf Lager';
      knapp = true;
    } else if (b.gezaehlt) {
      text = 'Auf Lager';
    } else {
      text = 'Verfügbar';
    }
    stockEl.innerHTML = text;
    stockEl.classList.toggle('is-knapp', knapp);
    stockEl.classList.toggle('is-aus', !b.da);
  }
  
  function formatMoney(cents) {
    return new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR'
    }).format(cents / 100);
  }
  
  // ==========================================
  // DELIVERY DATE CALCULATION
  // ==========================================
  
  /* Liefertermin als Datum statt „3-4 Werktage“: Wer ein Datum sieht, plant
     schon mit dem Paket. Werktage ohne Wochenende, Feiertage nicht
     eingerechnet – darum „voraussichtlich“. Hat das Produkt eine eigene
     Vorlaufzeit (Metafeld custom.lieferzeit, z. B. „5-7“), kommt sie dazu. */
  function spanne(text) {
    const m = (text || '').toString().match(/(\d+)\s*[-–]\s*(\d+)/);
    if (m) return [parseInt(m[1], 10), parseInt(m[2], 10)];
    const e = (text || '').toString().match(/(\d+)/);
    return e ? [parseInt(e[1], 10), parseInt(e[1], 10)] : null;
  }

  function calculateDeliveryDate() {
    if (!deliveryDateEl) return;
    const versand = spanne(deliverySettings && deliverySettings.standardVersand) || [3, 4];
    const vorlauf = spanne(deliverySettings && deliverySettings.lieferzeit) || [0, 0];
    const von = addBusinessDays(new Date(), versand[0] + vorlauf[0]);
    const bis = addBusinessDays(new Date(), versand[1] + vorlauf[1]);
    const tag = (d) => d.toLocaleDateString('de-DE', { weekday: 'short', day: 'numeric', month: 'short' });
    const spanneText = (von.toDateString() === bis.toDateString()) ? tag(von) : tag(von) + ' – ' + tag(bis);
    deliveryDateEl.innerHTML = 'Voraussichtlich bei dir: <strong>' + spanneText + '</strong>';
  }
  
  function addBusinessDays(date, days) {
    let currentDate = new Date(date);
    let addedDays = 0;
    
    while (addedDays < days) {
      currentDate.setDate(currentDate.getDate() + 1);
      
      // Skip weekends (Saturday = 6, Sunday = 0)
      if (currentDate.getDay() !== 0 && currentDate.getDay() !== 6) {
        addedDays++;
      }
    }
    
    return currentDate;
  }
  
  // Initialize delivery date - use setTimeout to ensure DOM is fully loaded
  setTimeout(function() {
    try {
      calculateDeliveryDate();
    } catch (error) {
      console.error('RK Product Hero - Error in calculateDeliveryDate:', error);
    }
  }, 100);
  
  // ==========================================
  // QUANTITY CONTROLS
  // ==========================================
  
  if (qtyMinus) {
    qtyMinus.addEventListener('click', function() {
      const currentQty = parseInt(qtyInput.value) || 1;
      if (currentQty > 1) {
        qtyInput.value = currentQty - 1;
      }
    });
  }
  
  if (qtyPlus) {
    qtyPlus.addEventListener('click', function() {
      const currentQty = parseInt(qtyInput.value) || 1;
      qtyInput.value = currentQty + 1;
    });
  }
  
  // ==========================================
  // ADD TO CART
  // ==========================================
  
  /* Gemeinsamer Weg in den Warenkorb für Kaufknopf, Sticky-Leiste und die
     kleinen Plus-Knöpfe. Shopify liefert die neu gezeichnete Schublade und
     das Korb-Symbol gleich mit (sections=…), die Schublade geht auf.
     Vorher blieb nach dem Klick nur „Hinzugefügt!“ am Knopf stehen – kein
     Korb, keine neue Zahl am Symbol. */
  function inDenKorb(daten, optionen) {
    const schublade = document.querySelector('cart-drawer');
    const formData = daten instanceof FormData ? daten : (function () {
      const f = new FormData();
      Object.keys(daten).forEach(function (k) { f.append(k, daten[k]); });
      return f;
    })();
    /* Nähpaket (19.10.2026): Ist „Mit Papierschnittmuster“ gewählt, gehen Paket und Schnittmuster zusammen in
       den Korb – je Paket ein Schnittmuster, als eigener Artikel (eigenes Lager). Gilt für Kaufknopf und Sticky-Leiste. */
    const sm = !(optionen && optionen.leise) && document.querySelector('input[data-rk-sm]:checked');
    if (sm && sm.value && formData.get('id')) {
      const id = formData.get('id'), menge = formData.get('quantity') || '1';
      formData.delete('id'); formData.delete('quantity');
      formData.append('items[0][id]', id); formData.append('items[0][quantity]', menge);
      formData.append('items[1][id]', sm.value); formData.append('items[1][quantity]', menge);
      if (sm.dataset.paket) formData.append('items[1][properties][Zum Nähpaket]', sm.dataset.paket);
    }
    if (schublade) {
      formData.append('sections', 'cart-drawer,cart-icon-bubble');
      formData.append('sections_url', window.location.pathname);
    }
    return fetch(window.routes && window.routes.cart_add_url ? window.routes.cart_add_url + '.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
      .then(function (antwort) { return antwort.json().then(function (j) { return { ok: antwort.ok, daten: j }; }); })
      .then(function (e) {
        if (!e.ok || e.daten.status) {
          throw new Error(e.daten.description || e.daten.message || 'Das hat nicht geklappt. Bitte versuch es noch einmal.');
        }
        if (schublade && e.daten.sections) {
          if (optionen && optionen.leise) {
            const blase = document.getElementById('cart-icon-bubble');
            if (blase && e.daten.sections['cart-icon-bubble']) {
              const neu = new DOMParser().parseFromString(e.daten.sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
              if (neu) blase.innerHTML = neu.innerHTML;
            }
            const drawerInhalt = e.daten.sections['cart-drawer'];
            if (drawerInhalt) {
              const ziel = document.getElementById('CartDrawer');
              const quelle = new DOMParser().parseFromString(drawerInhalt, 'text/html').querySelector('#CartDrawer');
              if (ziel && quelle) { ziel.innerHTML = quelle.innerHTML; schublade.classList.remove('is-empty'); }
            }
          } else {
            /* Wie das Grundtheme: Eine vorher leere Schublade verliert ihre
               Leer-Markierung, sonst bleiben Kopf und Artikel ausgeblendet. */
            schublade.classList.remove('is-empty');
            schublade.renderContents(e.daten);
          }
        } else if (!schublade && !(optionen && optionen.leise)) {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
        document.dispatchEvent(new CustomEvent('cartUpdated'));
        document.dispatchEvent(new CustomEvent('rk:warenkorb-geaendert'));
        return e.daten;
      });
  }
  window.rkInDenKorb = inDenKorb;

  const fehlerEl = document.getElementById('rk-kb-fehler');
  if (productForm) {
    productForm.addEventListener('submit', function(e) {
      e.preventDefault();
      const button = addToCartBtn || this.querySelector('button[type="submit"]');
      const originalHTML = button.innerHTML;
      if (fehlerEl) fehlerEl.hidden = true;
      button.disabled = true;
      button.classList.add('is-laedt');
      button.innerHTML = '<span class="rk-product-hero__spinner" aria-hidden="true"></span><span class="rk-kb__sr">Wird hinzugefügt</span>';

      inDenKorb(new FormData(this))
        .then(function () {
          button.classList.remove('is-laedt');
          button.classList.add('is-drin');
          button.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>Im Warenkorb';
          setTimeout(function () {
            button.classList.remove('is-drin');
            button.innerHTML = originalHTML;
            button.disabled = false;
          }, 2200);
        })
        .catch(function (fehler) {
          button.classList.remove('is-laedt');
          button.innerHTML = originalHTML;
          button.disabled = false;
          if (fehlerEl) { fehlerEl.textContent = fehler.message; fehlerEl.hidden = false; }
        });
    });
  }

  /* Gleich mitnehmen: ein Tipp legt das Teil in den Korb, ohne die Seite zu
     verlassen. Die Schublade bleibt zu, der Knopf zeigt einen Haken. */
  productSection.querySelectorAll('[data-rk-quer-id]').forEach(function (knopf) {
    knopf.addEventListener('click', function () {
      if (knopf.classList.contains('is-drin')) return;
      knopf.disabled = true;
      knopf.classList.add('is-laedt');
      inDenKorb({ id: knopf.getAttribute('data-rk-quer-id'), quantity: 1 }, { leise: true })
        .then(function () {
          knopf.classList.remove('is-laedt');
          knopf.classList.add('is-drin');
          knopf.disabled = false;
          knopf.setAttribute('aria-label', 'Im Warenkorb');
          knopf.querySelector('.rk-kb__quer-zeichen').textContent = '✓';
        })
        .catch(function () {
          knopf.classList.remove('is-laedt');
          knopf.disabled = false;
        });
    });
  });
  
  // ==========================================
  // WISHLIST
  // ==========================================
  
  if (wishlistBtn) {
    // Load wishlist state
    const wishlist = JSON.parse(localStorage.getItem('rk-wishlist') || '[]');
    const productId = wishlistBtn.dataset.productId;
    
    if (wishlist.includes(productId)) {
      wishlistBtn.classList.add('rk-product-hero__wishlist--active');
    }
    
    wishlistBtn.addEventListener('click', function() {
      this.classList.toggle('rk-product-hero__wishlist--active');
      
      let wishlist = JSON.parse(localStorage.getItem('rk-wishlist') || '[]');
      
      if (this.classList.contains('rk-product-hero__wishlist--active')) {
        if (!wishlist.includes(productId)) {
          wishlist.push(productId);
        }
      } else {
        wishlist = wishlist.filter(id => id !== productId);
      }
      
      localStorage.setItem('rk-wishlist', JSON.stringify(wishlist));
      
      // Dispatch event
      document.dispatchEvent(new CustomEvent('wishlistUpdated', { 
        detail: { count: wishlist.length } 
      }));
    });
  }
  
  // ==========================================
  // SHARE
  // ==========================================
  
  if (shareBtn) {
    shareBtn.addEventListener('click', function() {
      if (navigator.share) {
        navigator.share({
          title: document.title,
          url: window.location.href
        }).catch(err => console.log('Share failed:', err));
      } else {
        // Fallback: Copy to clipboard
        navigator.clipboard.writeText(window.location.href).then(function() {
          const originalText = shareBtn.innerHTML;
          shareBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"/></svg>Link kopiert!';
          
          setTimeout(function() {
            shareBtn.innerHTML = originalText;
          }, 2000);
        });
      }
    });
  }
  
  // ==========================================
  // ZOOM / LIGHTBOX
  // ==========================================
  
  if (zoomBtn && lightbox) {
    const lightboxImg = document.getElementById('rk-lightbox-img');
    const lightboxClose = lightbox.querySelector('.rk-product-hero__lightbox-close');
    
    zoomBtn.addEventListener('click', function() {
      const zoomUrl = mainImg.dataset.zoom;
      if (zoomUrl && lightboxImg) {
        lightboxImg.src = zoomUrl;
        lightbox.classList.add('rk-product-hero__lightbox--active');
        document.body.style.overflow = 'hidden';
      }
    });
    
    function closeLightbox() {
      lightbox.classList.remove('rk-product-hero__lightbox--active');
      document.body.style.overflow = '';
    }
    
    if (lightboxClose) {
      lightboxClose.addEventListener('click', closeLightbox);
    }
    
    lightbox.addEventListener('click', function(e) {
      if (e.target === this) {
        closeLightbox();
      }
    });
    
    // ESC key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && lightbox.classList.contains('rk-product-hero__lightbox--active')) {
        closeLightbox();
      }
    });
  }
  
})();